module.exports = __webpack_public_path__ + "static/media/vg.eef14ab6.svg";